import * as React from 'react';
import { UIHeading3 } from '@cian/ui-kit';

import { ITotalRowProps } from '../../types';
import * as styles from './TotalRow.css';

export const TotalRow = ({ total }: ITotalRowProps) => (
  <div className={styles['row']}>
    <UIHeading3 whiteSpace="nowrap">Сейчас к оплате</UIHeading3>
    <div className={styles['divider']} />
    <div data-name="total_cost">
      <UIHeading3 whiteSpace="nowrap">{total}</UIHeading3>
    </div>
  </div>
);
